module.exports = __webpack_public_path__ + "img/cloud.32da1907.png";